"use client";
import { useEffect, useState } from "react";

/**
 * Hook that safely provides the current time without causing hydration issues.
 * Returns null during SSR and initial render, then updates to current time after hydration.
 *
 * @param inSeconds - If true, returns time in seconds (Unix timestamp), otherwise milliseconds
 * @returns Current timestamp or null during SSR
 */
export function useCurrentTimeInSeconds(): number | null {
  const [currentTime, setCurrentTime] = useState<number | null>(null);

  useEffect(() => {
    const time = Date.now();
    setCurrentTime(time / 1000);
  }, []);

  return currentTime;
}
